import logger from './logger';

export const buildURLSuffix = (store: string, params: object, version = 0, _options: {decode?: boolean} = {}) => {
  const searchParams = new URLSearchParams();

  const zustandStoreParams = {
    state: params,
    version,
    // version is here because that is included with how Zustand sets the state
  };

  // The URL param key should match the name of the store, as specified as in storageOptions above
  searchParams.set(store, JSON.stringify(zustandStoreParams));

  return searchParams.toString();
};

export const buildShareableUrl = (storeName: string, params: object, version: number) => {
  return `${window.location.origin}?${buildURLSuffix(storeName, params, version)}`;
};

/**
 * Prevent open redirect: new URL() throws for relative paths (safe) but succeeds
 * for absolute URLs like https://evil.com, //evil.com, or javascript: (unsafe).
 * The startsWith('/') check rejects relative paths without a leading slash.
 */
export const isSafeRelativeUrl = (url: string | undefined): boolean => {
  if (!url) return false;
  try {
    new URL(url);
    return false;
  } catch {
    return url.startsWith('/');
  }
};

export const safeUrl = (url: string, shouldThrow: boolean = true) => {
  try {
    return new URL(url);
  } catch {
    if (!shouldThrow) {
      logger.error(`Error constructing url URL: ${url}`);
      return null;
    }

    throw new InvalidURL(url);
  }
};

/**
 * @description If Invalid URL is supplied to the URL constructor it throws an error without the URL
 * This error is just an extension of that error with the URL included
 */
class InvalidURL extends Error {
  constructor(url: string) {
    super(`Error constructing url URL: ${url}`);
  }
}
